import { AxiosPublic } from "../config/axios";

export async function mergeImage(id, frameId, width, passpartout) {
  return await AxiosPublic.get("painting/merge-images/" + id + (frameId ? `/${frameId}` : ''), { params: { width, passpartout } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}